
function doClose(data) {
	return {
		url: `/morty/assistant/response/close/${data.requestKey}`,
		method: 'POST',
		body: { text: `${data.text}` }
	};
}


function doQuestion(data) {
	return {
		url: `/morty/assistant/response/question/${data.requestKey}`,
		method: 'POST',
		body: { text: `${data.text}` }
	};
}


function doRecall(data) {
	return {
		url: `/morty/assistant/response/recall/${data.requestKey}`,
		method: 'POST',
		body: { }
	};
}

export { doClose, doQuestion, doRecall };
